module.exports = __webpack_public_path__ + "static/media/dec-thumb-seal-large.f17a2f2b.png";